<template>
  <div id="app">
    <layout></layout>
  </div>
</template>

<script>
import Vue from "vue"
import layout from './components/layout'
import {mapState} from "vuex"
export default {
  name: 'app',
  components: {
      layout
  },
  data(){
    return {
      platform:""
    }
  },
  ...mapState({
      isLogin: (state)=> state.user.isLogin,
    }),
  created(){
    Vue.prototype.$platform = ""
    function ready() {
      if(window.__wxjs_environment === "miniprogram"){
        Vue.prototype.$platform = "miniProgram"
      }
    }
    if (!window.WeixinJSBridge || typeof WeixinJSBridge == 'undefined') {
      document.addEventListener('WeixinJSBridgeReady', ready, false)
    } else {
      ready()
    }

    if(this.$route.query.minit){
      Vue.prototype.$platform = "miniProgram"
    }
    let that = this;
    window.openApp = function(pf){
      // alert(pf+"app")
      Vue.prototype.$platform = pf;
    }
  },
  mounted() {
    let that = this
    // this.$store.dispatch("user/checkLogin").then(res=>{
    //   console.log("isLogin",that.isLogin)
    //   if(!this.isLogin){
    //     return
    //   }
    
    // })
           
    // this.getStatisToken()
  },
  methods:{
    async getStatisToken() {
      let statisParams={
          "sessionId":this.generateGuid(),
          "loginUser":"h5_visitor",
          "password":"xZsVty8RDW"
      }
      try{
        let statisRes = await this.$service.getStatisToken(statisParams);
        if(statisRes.status=='200'){
          localStorage.setItem(this.$env+"statisToken",statisRes.h5_token);
          // this.$service.getStatisCommon("evn_init_page",{});
        }
      }catch(e){
        console.log(e)
      }
    },
    generateGuid(){
      return localStorage.getItem("burrySessionId")
      // function s4() {
      //   return Math.floor((1 + Math.random()) * 0x10000)
      //     .toString(16)
      //     .substring(1);
      // }
      // const PRE = 's_';
      // return PRE + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }
}
</script>

<style>
@import url(//at.alicdn.com/t/font_2577436_pq50gfc99m.css);
.mvh100{
  min-height: 100vh;
}
.h100{
  height: 100%;
}
.flex{
  display:flex;
  flex-direction: row;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-1{
  flex:1
}
.flex-col{
  flex-direction: column;
}
.flex-between{
  justify-content: space-between;
}
.flex-row-center{
  justify-content: center;
}
.flex-row-end{
  justify-content: flex-end;
}
.flex-row{
  flex-direction: row;
}
.flex-col-center{
  align-items: center;
}
.flex-self-center{
  align-self: center;
}
.m-t-6{
  margin-top: 6px;
}
.m-5{
  margin: 5px 0;
}
.m-t-10{
  margin-top: 10px;
}
.shadow {
  box-shadow: 0px 1px 4px 0px #de3506;
}
.op30{
  opacity: .3;
}
.op46{
  opacity: .46;
}
.op68{
  opacity: .68;
}
.backf4{
  background: #F4F4F4;
}
.back-white{
  background:#FFFFFF;
}
.color-white{
  color: #FFFFFF;
}
.font500{
  font-weight: 500;
}
.padding-10{
  padding: 10px;
}

.money-text {
  color: #f84f24 !important;
}
.font-10 {
  font-size: 10px;
}
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.flex-col-bottom{
  align-items: flex-end;
}
.coupon-no-data{
  margin-left: 36px;
}
</style>
<style lang="less">
@import './style/reset.less';
@import './style/common.less';
</style>
